import { useGlobalStore } from '~/stores/global';
import { useInteractiveStore } from '~/stores/interactive';

export default defineNuxtPlugin(() => {
  const interactiveStore = useInteractiveStore();
  const globalStore = useGlobalStore();
  const runtimeConfig = useRuntimeConfig();
  const isProd = runtimeConfig.public.isProd;
  if (interactiveStore.isPageSpeedBot || !isProd || globalStore.webview) return;

  function init() {
    const _tmr = window._tmr || (window._tmr = []);
    _tmr.push({ id: '3499389', type: 'pageView', start: new Date().getTime() });
    (function (d, w, id) {
      if (d.getElementById(id)) return;
      const ts = d.createElement('script');
      ts.type = 'text/javascript';
      ts.async = true;
      ts.id = id;
      ts.src = 'https://top-fwz1.mail.ru/js/code.js';
      const f = function () {
        const s = d.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(ts, s);
      };
      if (w.opera == '[object Opera]') {
        d.addEventListener('DOMContentLoaded', f, false);
      } else {
        f();
      }
    })(document, window, 'tmr-code');
  }

  interactiveStore.addFunction(init);
});
